<script>
import baseList from "@/views/components/base/baseList.vue";
export default {
  extends: baseList,
  components: {},
  data() {
    return {
      table: {
        mname: "performanceRule",
        key: "id",
        url: {
          list: "/admin/system/performanceRule/listAll",
          del: "/admin/system/performanceRule",
        },
        output: false,
      },
      actions: [
        {
          label: "新增",
          icon: "md-add",
          onClick: this.toAdd,
          type: "info",
        },
      ],
      menus: [],
      query: {},
      filters: [
        {
          label: "客户名称",
          KeyEnter: this.search,
          name: "customerName",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "客户名称",
          key: "customerName",
          minWidth: 160,
          align: "center",
        },
        {
          title: "工单数量",
          key: "monthlyTargetCount",
          minWidth: 220,
          align: "center",
        },
        // {
        //   title: "绩效薪资",
        //   width: 150,
        //   align: "center",
        //   key: "performanceSalary",
        // },
        {
          title: "操作",
          align: "center",
          width: 180,
          key: "handle",
          handle: [
            "edit",
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    margin: "0 0 0 5px",
                  }}
                >
                  详情
                </Button>
              );
            },
            ,
            "delete",
          ],
        },
      ],
    };
  },
  created() {},
  methods: {
    toAdd() {
      $utils.url.push({
        name: "performance_admin_edit",
        query: { action: "add" },
      });
    },
    toInfo(currentRow) {
      $utils.url.push({
        name: "performance_admin_info",
        query: {
          kv: currentRow.customerId,
          monthlyTargetCount: currentRow.monthlyTargetCount,
        },
      });
    },
    handleEdit(currentRow) {
      console.log(currentRow);

      let kv = currentRow.id;
      $utils.url.push({
        name: "performance_admin_edit",
        query: { action: "edit", kv },
      });
    },
  },
};
</script>
